import React from "react";
import {useTabs} from '../../hooks/useTabs';
import {useDragOrderItems} from './hooks/useDragOrderItems';

export const OrderContext = React.createContext<
    | {
          tabs: ReturnType<typeof useTabs>;
          dragOrderItems: ReturnType<typeof useDragOrderItems>;
      }
    | undefined
>(undefined);

export const useOrderContext = () => {
    const context = React.useContext(OrderContext);
    if (context === undefined) {
        throw new Error("useOrderContext must be within the correct provider");
    }
    return context;
};

export const OrderContextProvider = ({ children }: { children: React.ReactElement }) => {
    const tabs = useTabs("details");
    const dragOrderItems = useDragOrderItems();
    return <OrderContext.Provider value={{ tabs, dragOrderItems }}>{children}</OrderContext.Provider>;
};

